import { FunctionComponent, useEffect, useState } from "react";
import Navbar from "../Components/Navbar/Navbar";
import SuperAdminPanel from "../Screens/SuperAdminPanel/SuperAdminPanel";
import AddOrganization from "../Screens/AddOrganization/AddOrganization";
import { Route } from "react-router-dom";
import EditOrganization from "../Screens/EditOrganization/EditOrganization";
import styles from '../Screens/Analytics/Analytics.module.css'
import AnalyticsSideNav from "../Components/AnalyticsSideNav/AnalyticsSideNav";
import Headers from "../Screens/Headers/HeaderPanel";
import AddHeaders from "../Screens/AddHeaders/AddHeaders";
import EditHeaders from "../Screens/EditHeaders/EditHeaders";
import LeadManagerAnalytics from "../Screens/Analytics/LeadManagerAnalytics";
import { fetchOrganizationsUsersAuthId } from "../Services/users";
import { connect, useDispatch } from "react-redux";
import AddLicensesCost from "../Screens/AddLicensesCost/AddLicensesCost";
import UserList from "../Screens/UserList/UserList";
import AddUsers from "../Screens/AddUsers/AddUsers";
import FAQPanel from "../Screens/SuperAdminFAQPanel/FAQPanel"
import AdminAddFAQ from "../Screens/AddFAQ/AdminAddFAQ";
import AdminEditFAQ from "../Screens/EditFAQ/AdminEditFAQ ";
import NewsPanel from "../Screens/NewsPanel/NewsPanelSuperAdmin";
import ResourcesSuperAdmin from "../Screens/Resources/ResourcesSuperAdmin";
import Booking from "../Screens/BookingForm/Booking";
import AddBooking from "../Screens/BookingForm/AddBooking";
import ViewBooking from "../Screens/Booking/AddBooking";
import CouponList from "../Screens/CouponList/CouponList";
import AddCoupon from "../Screens/AddCoupon/AddCoupon";
import MyProfile from "../Screens/MyProfile/MyProfile";
import PolicyPrivacy from "../Screens/PolicyPrivacy/PolicyPrivacy";
import AboutUs from "../Screens/AboutUs/AboutUs";
import BookingFormIndustries from "../Screens/BookingForm/BookingFormIndustries";
import UserPanelSuperAdmin from "../Screens/UserPanel/UserPanelSuperAdmin";
import TaskPanelSuperAdmin from "../Screens/TasksPanel/TaskPanelSuperAdmin";
import CallLogsPanelSuperAdmin from "../Screens/CallLogsPanel/CallLogsPanelSuperAdmin";
import SortPanelSuperAdmin from "../Screens/UserPanel/SortPanelSuperAdmin";
import BookingSuperAdmin from "../Screens/Booking/BookingSuperAdmin";
import ProjectsPanelSuperAdmin from "../Screens/ProjectsPanel/ProjectsPanelSuperAdmin";
import ApiPanelSuperAdmin from "../Screens/ApiPanel/ApiPanelSuperAdmin";
import AddProjectSuperAdmin from "../Screens/AddProject/AddProjectSuperAdmin";
import UpdatePasswordReplicated from "../Screens/UpdatePassword/UpdatePasswordReplicated";
import SimplyWhatsAppIntegration from "../Screens/WhatsAppIntegration/SimplyWhatsAppIntegration";
import ChatSimplifiedIntegration from "../Screens/WhatsAppIntegration/ChatSimplifiedIntegration";
import EditMasterProjectModal from "../Components/Modals/ProjectEditModal/EditMasterProjectModal";
import AddMasterContacts from "../Screens/AddContacts/AddMasterContacts";
import WAPIWhatsAppIntegration from "../Screens/WhatsAppIntegration/WAPIWhatsAppIntegration";
import WhatsAppIntegrationList from "../Screens/WhatsAppIntegration/WhatsAppIntegrationList";
import ProjectDetails from "../Screens/ProjectDetails/ProjectDetails";


type props = {
  user: any;
  history: any;
  leadsStage: any;
  organizationUsers: any;
  showDeactivationAlert: any;
  paymentStatus: any;
};

const SuperAdminRoute: FunctionComponent<props> = ({
  history,
  user,
  leadsStage,
  organizationUsers,
  showDeactivationAlert,
  paymentStatus
}) => {
  const dispatcher = useDispatch();

  useEffect(() => {
    const localStoreOrgObj = localStorage.getItem("superAdminSelectedOrg");
    if (localStoreOrgObj != null) {
      const covertObj = JSON.parse(localStoreOrgObj);
      const orgAuthId = covertObj.value;

      if (orgAuthId) {
        const unSub = fetchOrganizationsUsersAuthId(
          dispatcher,
          orgAuthId,
          user
        );
        return () => {
          unSub();
        };
      }
    }
  }, [user, localStorage.getItem("superAdminSelectedOrg")]);

  return (
    <>
      <Navbar
        props={{ history }}
        title={"Organizations"}
        path={"/"}
        leadManger={false}
      />
      <div className={styles.parent} style={{ overflow: "hidden", height: "100vh" }}>
        <AnalyticsSideNav
          props={{ history }}
          title={"Organizations"}
          path={"/"}
          leadManger={false}
          operationManger={false}
        />
        <Route exact path="/" component={SuperAdminPanel} />
        <Route exact path="/userlist" component={UserList} />
        <Route path="/addUsers" component={AddUsers} />
        <Route path="/addHeaders" component={AddHeaders} />
        <Route path="/headers" component={Headers} />
        <Route path="/editOrganizations" component={EditOrganization} />
        <Route path="/editHeaders" component={EditHeaders} />
        <Route path="/analytics" component={LeadManagerAnalytics} />
        <Route path="/addOrganizations" component={AddOrganization} />
        <Route path="/addCost" component={AddLicensesCost} />
        <Route path="/couponlist" component={CouponList} />
        <Route path="/addcoupon" component={AddCoupon} />
        <Route path="/bookingForm" component={Booking} />
        <Route path="/addForm" component={AddBooking} />
        <Route path="/editForm" component={AddBooking} />
        <Route path="/faq" component={FAQPanel} />
        <Route path="/addFAQ" component={AdminAddFAQ} />
        <Route path="/editFAQ" component={AdminEditFAQ} />
        <Route path="/news" component={NewsPanel} />
        <Route path="/resources" component={ResourcesSuperAdmin} />
        <Route path="/profile" component={MyProfile} />
        <Route path="/privacy-policy" component={PolicyPrivacy} />
        <Route path="/about-us" component={AboutUs} />
        <Route path="/addBookingForm" component={BookingFormIndustries} />
        <Route path="/contacts" component={UserPanelSuperAdmin} />
        <Route path="/tasks" component={TaskPanelSuperAdmin} />
        <Route path="/callLogs" component={CallLogsPanelSuperAdmin} />
        <Route path="/sorted" component={SortPanelSuperAdmin} />
        <Route path="/booking" component={BookingSuperAdmin} />
        <Route path="/viewBookingDetails" component={ViewBooking} />
        <Route path="/apis" component={ApiPanelSuperAdmin} />
        <Route path="/projects" component={ProjectsPanelSuperAdmin} />
        <Route path="/addProjects" component={AddProjectSuperAdmin} />
        <Route path="/updatePassword" component={UpdatePasswordReplicated} />
        <Route path="/simplyWhatsAppIntegration" component={SimplyWhatsAppIntegration} />
        <Route path="/wapiWhatsAppIntegration" component={WAPIWhatsAppIntegration} />
        <Route path="/chatSimplifiedIntegration" component={ChatSimplifiedIntegration} />
        <Route path="/whatsAppIntegration" component={WhatsAppIntegrationList} />
        <Route path="/editProjects" component={EditMasterProjectModal} />
        <Route path="/addContacts" component={AddMasterContacts} />
        <Route path="/projectDetails" component={ProjectDetails} />
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    leadsStage: state.leadsStage.stage,
    organizationUsers: state.organizationUsers.data,
    showDeactivationAlert: state.organization.showDeactivationAlert,
    paymentStatus: state.organization.paymentStatus
  };
};
export default connect(mapStateToProps)(SuperAdminRoute);
